var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Communication/Mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42609 5.44929L9.99935 9.83147L16.5726 5.44929C16.4338 5.18215 16.1545 4.99967 15.8327 4.99967H4.16602C3.84415 4.99967 3.56491 5.18215 3.42609 5.44929ZM16.666 7.39011L10.4616 11.5264C10.1817 11.713 9.81702 11.713 9.5371 11.5264L3.33268 7.39011V14.1663C3.33268 14.6266 3.70578 14.9997 4.16602 14.9997H15.8327C16.2929 14.9997 16.666 14.6266 16.666 14.1663V7.39011ZM1.66602 5.83301C1.66602 4.4523 2.7853 3.33301 4.16602 3.33301H15.8327C17.2134 3.33301 18.3327 4.4523 18.3327 5.83301V14.1663C18.3327 15.5471 17.2134 16.6663 15.8327 16.6663H4.16602C2.7853 16.6663 1.66602 15.5471 1.66602 14.1663V5.83301Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.22e380501c51e93eb6ec2a0d4f81cee2.svg";
export { ForwardRef as ReactComponent };